import EditorViewState from '../store/schema/EditorViewState';
import { callEditorApi } from './callApi';
import { QueryScope } from 'roosterjs-editor-types';

/**
 * Get selected image
 * @param viewState The editor viewstate
 * @param includeEditorSelection When pass true, if there is no selected image from viewState, try to get selected image from editor
 */
export default function getSelectedImage(
    viewState: EditorViewState,
    includeEditorSelection?: boolean
) {
    let result = viewState.selectedImage;

    if (!result && includeEditorSelection) {
        const images = callEditorApi(viewState, 'queryElements', 'img', QueryScope.OnSelection);
        result = images?.[0] as HTMLImageElement;
    }

    return result;
}
